var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100"},[_c('iframe',{ref:"iframePage",attrs:{"src":_vm.queryItem.url,"name":"iframe","width":"100%","frameborder":"0","scrolling":"auto","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }